import { Pipe, PipeTransform } from '@angular/core';
import { TranslateApplicationService } from '../translate/translate-application-service';
import { TranslateService } from '../services/translate-service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {


  constructor(
    private translate: TranslateApplicationService,
    private translateOrigin: TranslateService) { }


  transform(key: any, parameters: object): any {
    return Object.keys(this.translate.data).length != 0  ? this.translateKey(key, parameters, this.translate) : this.translateKey(key, parameters, this.translateOrigin)
  }

  translateKey(key: any, parameters: object, translateData: any): any {
    if (key.split(".").length == 1)
      return translateData.data[key] || key;
    else {
      let arrayKey: any;
      arrayKey = key.split(".");
      let valueFind: any = "";

      let index: number = 0;

      for (let item of arrayKey) {
        if (index == 0)
          valueFind = translateData.data[item];
        else {
          valueFind = valueFind == undefined ? key : valueFind[item];
        }

        index++;
      }

      if (valueFind && parameters) {
        Object.keys(parameters).forEach(key => {
          if (valueFind.includes("{" + key + "}"))
            valueFind = valueFind.replace("{" + key + "}", parameters[key]);
        });
      }

      return valueFind;
    }
  }
}
